import { rem, stripUnit } from 'polished'
import styled from 'styled-components'
import theme from 'styles/theme'
import { Body14 } from 'components/Typography'
import { GatsbyImage } from 'gatsby-plugin-image'

export const Wrapper = styled.div``

export const Grid = styled.div`
  margin: 0 auto;
  max-width: 640px;
  padding: 0 20px;

  ${theme.mediaQueries.large} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 980px;
    padding: 0;
  }
`

export const Card = styled.article`
  margin: 0;
  text-align: center;

  ${theme.mediaQueries.large} {
    flex: none;
    margin: 0;
    width: calc(50% - 10px);
  }

  &:first-child:last-child {
    ${theme.mediaQueries.large} {
      margin-left: auto;
      margin-right: auto;
    }
  }

  &:nth-child(n + 2) {
    ${theme.mediaQueries.mobile} {
      margin-top: 60px;
    }
  }

  &:nth-child(n + 3) {
    ${theme.mediaQueries.large} {
      margin-top: 75px;
    }
  }

  .cta {
    display: block;
    margin: 30px auto 0;
    padding: ${rem(20)};
    width: 100%;

    ${theme.mediaQueries.large} {
      max-width: 280px;
    }
  }
`

export const Picture = styled.picture`
  display: block;
  width: 100%;
  hieght: 100%;
`

export const Image = styled(GatsbyImage)`
  display: block;
  height: calc(100vw - ${stripUnit(theme.space[4]) * 2}em);
  max-height: 600px;
  width: 100%;

  ${theme.mediaQueries.large} {
    max-height: 640px;
  }
`

export const CardBody = styled.div`
  margin: 0 auto;
  max-width: 340px;
  padding: 20px 20px 0;

  ${theme.mediaQueries.large} {
    max-width: none;
  }
`

export const CardText = styled(Body14)`
  color: ${theme.colors.sagemedium};
  margin: 10px 0 0;
`
